import { safetyPageInitialState } from "./uiLandingPageSafetyPageState";
import { makeSafetyPageActions } from "./uiLandingPageSafetyPageActions";

export const createSafetyPageSlice = (set, get) => ({
  safetyPage: safetyPageInitialState,
  safetyPageActions: makeSafetyPageActions(set, get),
});
